import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
function getActivityHistory({
  objectId,
  objectType,
  limit,
  offset
}) {
  return http.get(`/bet-crm-customer-summary/v1/activity-history/${objectType.toLowerCase()}/${objectId}`, {
    query: {
      limit,
      offset
    }
  });
}
const GetCustomerActivityHistoryFieldName = 'customerActivityHistory';
export const GET_CUSTOMER_ACTIVITY_HISTORY = registerQuery({
  args: ['objectType', 'objectId', 'limit', 'offset'],
  fetcher: getActivityHistory,
  fieldName: GetCustomerActivityHistoryFieldName
});
export function useActivityHistoryQuery(options) {
  return useQuery(GET_CUSTOMER_ACTIVITY_HISTORY, options);
}